import { useMemo } from 'react';
import { IFormValidation } from '@busybusy/webapp-react-ui';

export default function useTimeEntryEquipmentValidation(): Array<IFormValidation<string | null, any>> | undefined {
  return useMemo(() => undefined, []);
}
